const createMediaQuery = (breakpoint, property, value) => `
  @media (max-width: ${breakpoint}px) {
    ${property}: ${value};
  }
`;

export { createMediaQuery };
//# sourceMappingURL=createMediaQuery.js.map
